export const authTokenSelector = (state) => ({
  idToken: state.session.idToken,
  mockUserId: state.session.mockUserId
});



// WEBPACK FOOTER //
// ./src/state/modules/session/selectors.js